export default {
  errorPayments: {
    title: "Correcting and posting erroneous payments",
    errorPaymentsForm: {
      modal: {
        title: "Correcting and posting erroneous payments"
      },
      autoDistribute: "F2 - Post payment automatically after the change"
    }
  }
};
